module.exports = __webpack_public_path__ + "img/m.dee2e713.jpg";